import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import ColumnName from '@/util/ColumnName';
import {
  ConfigurationSelect,
  type ConfigurationSelectProps,
} from './ConfigurationSelect';

export const DraggableSelect: React.FC<
  ConfigurationSelectProps<ColumnName> & {
    id: string;
  }
> = ({
  id,
  index,
  options,
  selectedOption,
  onSelectRemove,
  onOptionSelect,
  draggable,
  isRequired,
}) => (
  <Draggable draggableId={id} index={index} isDragDisabled={!draggable}>
    {(providedDraggable) => (
      <ConfigurationSelect
        {...providedDraggable.draggableProps}
        {...providedDraggable.dragHandleProps}
        index={index}
        options={options}
        selectedOption={selectedOption}
        onSelectRemove={onSelectRemove}
        onOptionSelect={onOptionSelect}
        ref={providedDraggable.innerRef}
        draggable={draggable}
        isRequired={isRequired}
      />
    )}
  </Draggable>
);
